import fetch from '@strictsoftware/fetch';
import { NdpsDomainResponse } from '../../../types/bff-types';
import { configProviderManager } from '../../config-provider';

const cache = new Map<string, Promise<NdpsDomainResponse | null>>();

export const fetchBff = (path: string, formData?: FormData): Promise<NdpsDomainResponse | null> => {
	const headers = configProviderManager.getBffHeaders();
	const baseUrl = formData ? configProviderManager.getBffUrl() : configProviderManager.getBffCdnUrl();
	const url = `${baseUrl}/${path}`;

	if (!formData && cache.has(url)) return cache.get(url)!;

	const promise = fetch(url, {
		method: formData ? 'POST' : 'GET',
		headers: headers ? (headers as Record<string, string>) : {},
		body: formData,
	})
		.then((res) => res.json())
		.catch(() => null);

	if (!formData) cache.set(url, promise);
	return promise;
};
